<!-- Page Title -->
<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-content text-white">
                    <h2>Kontakt</h2>
                    <ul class="text-gray-200">
                        <li><a routerLink="/" class="hover:underline">Startseite</a></li>
                        <li>Kontakt</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <div class="default-shape hidden md:block">
        <div class="shape-1"><img src="assets/img/shape/1.png" alt="shape" /></div>
        <div class="shape-2 rotateme"><img src="assets/img/shape/2.png" alt="shape" /></div>
        <div class="shape-3"><img src="assets/img/shape/3.svg" alt="shape" /></div>
        <div class="shape-4"><img src="assets/img/shape/4.svg" alt="shape" /></div>
        <div class="shape-5"><img src="assets/img/shape/5.png" alt="shape" /></div>
    </div>
</div>

<!-- Impressum Content -->
<section class="py-20 bg-white">
    <div class="container mx-auto px-4 max-w-4xl text-gray-800">
        <div class="section-title">
            <h2>Kontaktiere uns</h2>
            <div class="bar"></div>
            <p>Du hast Fragen zur Anmeldung, zum Ferienkurs oder brauchst einfach eine persönliche Beratung? Wir freuen uns auf deine Nachricht!</p>
        </div>

        <div class="row align-items-center">
            <!-- Contact Form -->
            <div class="col-lg-6">
                <div class="contact-form">
                    <form id="contactForm">
                        <div class="row">
                            <!-- Anrede -->
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <label for="anrede">Anrede *</label>
                                    <select name="anrede" id="anrede" class="form-control" required>
                                        <option value="">Bitte wählen</option>
                                        <option value="frau">Frau</option>
                                        <option value="herr">Herr</option>
                                        <option value="divers">Divers</option>
                                    </select>
                                </div>
                            </div>

                            <!-- Thema -->
                            <div class="col-lg-12 col-md-12">
                                <label>Thema</label>
                                <div class="form-group d-flex flex-wrap gap-3">
                                    <div><input type="checkbox" name="thema" value="anmeldung"> Anmeldung</div>
                                    <div><input type="checkbox" name="thema" value="ferienkurs"> Ferienkurs</div>
                                    <div><input type="checkbox" name="thema" value="sonstiges"> Sonstiges</div>
                                </div>
                            </div>

                            <!-- Telefonnummer -->
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <input type="text" name="telefon" id="telefon" class="form-control" placeholder="Telefonnummer">
                                </div>
                            </div>

                            <!-- Vorname -->
                            <div class="col-lg-6 col-md-6">
                                <div class="form-group">
                                    <input type="text" name="vorname" id="vorname" class="form-control" required placeholder="Vorname *">
                                </div>
                            </div>

                            <!-- Name -->
                            <div class="col-lg-6 col-md-6">
                                <div class="form-group">
                                    <input type="text" name="name" id="name" class="form-control" required placeholder="Name *">
                                </div>
                            </div>

                            <!-- E-Mail -->
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <input type="email" name="email" id="email" class="form-control" required placeholder="E-Mail Adresse *">
                                </div>
                            </div>

                            <!-- Nachricht -->
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <textarea name="nachricht" id="nachricht" class="form-control" rows="5" required placeholder="Nachricht *"></textarea>
                                </div>
                            </div>

                            <!-- DSGVO -->
                            <div class="col-lg-12 col-md-12">
                                <div class="form-group">
                                    <label>
                                        <input type="checkbox" name="dsgvo" required>
                                        Ich habe die <a href="/datenschutz" target="_blank">Datenschutzerklärung</a> zur Kenntnis genommen und bin einverstanden, dass meine Daten zur Kontaktaufnahme gespeichert werden.
                                    </label>
                                </div>
                            </div>

                            <!-- Submit -->
                            <div class="col-lg-12 col-md-12">
                                <div class="send-btn">
                                    <button type="submit" class="default-btn">Senden <span></span></button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <!-- Contact Info -->

            <!-- Contact Info -->
            <div class="col-lg-6">
                <div class="contact-info">
                    <div class="contact-info-content">
                        <h3>Du erreichst uns direkt per Telefon oder E-Mail</h3>
                        <h2>
                            <a href="tel:+491771482503">0177 - 148 250 3</a>
                            <span>oder</span>
                            <a href="mailto:info@tommys-fs.de">info&commat;tommys-fs.de</a>
                        </h2>
                        <p><strong>Adresse:</strong><br>
                            Tommys Fahrschule<br>
                            Bahnhofstraße 95, 35390 Gießen
                        </p>
                        <ul class="social">
                            <li><a href="https://www.facebook.com/profile.php?id=100051045025672" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                            <li><a href="https://www.instagram.com/tommys_fahrschule" target="_blank"><i class="fab fa-instagram"></i></a></li>
                            <li><a href="https://wa.me/491771482503" target="_blank"><i class="fab fa-whatsapp"></i></a></li>
                        </ul>

                        <!-- Öffnungszeiten ajoutées ici -->
                        <div class="single-footer-widget mt-4">
                            <h3>Öffnungszeiten</h3>
                            <ul class="list">
                                <li>Montag: 15:00 – 17:00 Uhr</li>
                                <li>Dienstag: 15:00 – 17:00 Uhr</li>
                                <li>Mittwoch: 15:00 – 17:00 Uhr</li>
                                <li>Donnerstag: 15:00 – 17:00 Uhr</li>
                                <li>Freitag: Nach Vereinbarung</li>
                            </ul>
                        </div>
                        <!-- Fin Öffnungszeiten -->
                    </div>
                </div>
            </div>
        </div>


    </div>
</section>
<app-subscribe></app-subscribe>
